import React, { useEffect, useRef } from 'react';
import Popover from '@mui/material/Popover';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightToBracket,faCog} from "@fortawesome/free-solid-svg-icons";
import RenderSvg from "../renderSvg/RenderSvg";
import "./configurationDashboardOptions.css"
import { faUserLock } from '@fortawesome/free-solid-svg-icons';
import { configurationDashboardOptions } from '../../types';
import { Typography } from '@mui/material';
import store from '../../stateManagement/store';
import { useSelector } from 'react-redux'; // <-- ADD THIS
import { logoutUser } from '../../services/authenticationService';
import { eventEnum, logEvent } from '../../services/eventsService/eventService';
import { useNavigate } from 'react-router-dom';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';

export function ConfigurationDashboardOptions(props: configurationDashboardOptions) {
  const { translate } = usePortalTranslation();
  const navigate = useNavigate();
  // 🔍 Get the activeOption from Redux
  const activeOption: string = useSelector(
    (store: any) => store.configTypeState.activeOption
  );
  console.log('Current activeOption:', activeOption); 


  const firstButtonRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (props.anchorEl && firstButtonRef.current) {
      firstButtonRef.current.focus();
    }
  }, [props.anchorEl]);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>, action: () => void) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      action();
    }
  };

  return (
    <Popover
      id={props.id}
      open={Boolean(props.anchorEl)}
      anchorEl={props.anchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      onClose={props.handleClose}
      style={{ borderRadius: "10px !important" }}
      sx={{ overflow: "hidden"}}
      disableAutoFocus={false}
      disableEnforceFocus={false}
      PaperProps={{
        role: 'menu',
        'aria-label': 'Configuration options',
        sx: {
          boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
          borderRadius: 2,
        }
      }}
    >
      <div className='outerLogoutContainer'>
        {/* ✅ Only show Settings if activeOption is SalesCodeStudio */}
        {activeOption === "Salescode Studio" && (
          <div
            className='logoutContainer'
            onClick={() => {
              navigate("/dashboard/settings");
              props.handleClose(); // close the popover after clicking
            }}
          >
            <div className='settingsIcon'>
              <FontAwesomeIcon icon={faCog} />
            </div>
            <Typography variant='subtitle2'>
              {translate(TranslationEnum.navbar_options, "Settings")}
            </Typography>
          </div>
        )}
        {!props.disableChangePassword && <div
          className='logoutContainer'
          tabIndex={0}
          role="menuitem"
          ref={firstButtonRef}
          onClick={() => navigate("/dashboard/changePassword")}
          onKeyDown={(e) => handleKeyDown(e, () => navigate("/dashboard/changePassword"))}
        >
          <div className='changePasswordIcon'>
            <RenderSvg name={"password-reset"} />
          </div>
                     <Typography style={{ textAlign: "center", color: "rgb(87 84 84)" }} variant='subtitle2'>{translate(TranslationEnum.navbar_options, "Change Password")}</Typography>
         </div>}
         <div
           className='logoutContainer'
           tabIndex={0}
           role="menuitem"
           onClick={() => navigate("/dashboard/profile")}
           onKeyDown={(e) => handleKeyDown(e, () => navigate("/dashboard/profile"))}
         >
           <div className='profileIcon' style={{paddingRight: "8px"}}>
             <RenderSvg name={"user-profile"} />
           </div>
           <Typography style={{ textAlign: "center", color: "rgb(87 84 84)" }} variant='subtitle2'>{translate(TranslationEnum.navbar_options, "View Profile")}</Typography>
         </div>
         <div
           className='logoutContainer'
           tabIndex={0}
           role="menuitem"
           onClick={() => {
             logEvent(eventEnum.logout, { feature_name: "logout" });
             logoutUser();
           }}
           onKeyDown={(e) => handleKeyDown(e, () => {
             logEvent(eventEnum.logout, { feature_name: "logout" });
             logoutUser();
           })}
         >

          <div className='logoutIcon'>
            <RenderSvg name={"logout"} />
          </div>
          {/* <Typography variant='subtitle2'>{t("all.logout",{ defaultValue: "Logout" })}</Typography> */}
          <Typography style={{color: "rgb(87 84 84)"}} variant='subtitle2'>{translate(TranslationEnum.navbar_options, "Logout")}</Typography>
        </div>
      </div>
    </Popover>
  )
}